let config = {
  isLan: false, // true为本地、测试 false为生产 dev开发
  origin: window.location.origin
}

let isLanReg = /:6688/.test(config.origin) || /test.s.phone580.com/.test(config.origin) || /test.www.phone580.com/.test(config.origin)
config.isLan = isLanReg
// config.isLan = false
// config.isLan = 'dev'

let wwwRoot1 = config.isLan ? 'http://test.www.phone580.com:8000' : 'https://www.phone580.com'
let wwwRoot = config.isLan ? 'http://test.www.phone580.com:8000' : 'https://seckillapi.phone580.com'
let orderRoot = config.isLan ? 'http://test.orderapi.phone580.com:8000' : 'https://seckillapi.phone580.com'
let activityApi = config.isLan ? 'http://test.promotionapi.phone580.com:8000' : 'https://seckillapi.phone580.com'

if (config.isLan === 'dev') {
  wwwRoot1 = 'http://10.20.1.47:8082'
  wwwRoot = 'http://10.20.1.47:8082'
  orderRoot = 'http://10.20.1.47:8082'
  activityApi = 'http://10.20.1.47:8082'
}

export default {
  isLan: config.isLan, // false 即为正式服券
  imgSrc: wwwRoot1 + '/xfolder',
  login: wwwRoot + '/fzsuserapi/api/user/authloginv2', // 登录接口
  msgCode: wwwRoot + '/fzsuserapi/user/sendsmscode', // 下发短信验证码
  getGraphCode: wwwRoot1 + '/fzsCaptchaApi/captcah/captcah.jpg', // 图形验证码API
  placeorder: orderRoot + '/fzs-order-api/order/api/placeorder', // 统一下单接口
  secondPay: orderRoot + '/fzs-order-api/order/api/second-pay', // 二次支付
  getAllProductList: activityApi + '/fmapi/api/action/query-check-white-task-all', // 2.0.1白名单过滤的任务方案及下级信息(获取商品列表)
  searchRewardRecord: activityApi + '/fmapi/api/reward/query-user-receive-record-new', // 1.5 查询用户的领奖记录
  // openReward: activityApi + '/fmapi/api/reward/select-reward', // 1.20 用户开奖接口
  openReward: activityApi + '/fmapi/api/reward/user-receive-reward', // 1.7.1 领奖接口
  bocLogin: wwwRoot + '/fzsuserapi/api/user/authlogin-third-user', // 中行第三方登录
  getTaskRewardInfo: activityApi + '/fmapi/api/reward/get-task-reward-info', // 1.17.查询任务的奖励资格列表
  getRankList: activityApi + '/fmapi/api/reward/query-reward-show-record', // 1.6查询中奖轮播数据
  changeBocString: activityApi + '/fmapi/api/action/change-cipher-text', // 2.4.6转换加密串
  collectionUserAction: activityApi + '/fmapi/api/action/collect-user-action', // 1.3 收集用户行为
  getShareList: activityApi + '/fmapi/api/cptc/query-share-ranking-list', // 1.23.1 查询分享排行榜接口
  getWeChatSignature: 'https://openapi.phone580.com/wechat/openapi/getWechatSignature', // 获取微信签名 https://app.phone580.com/test
  getUserRankInfo: activityApi + '/fmapi/api/cptc/query-user-bocopenred-ranking', // 查询开门红活动用户的排名详情
  checkShareTime: activityApi + '/fmapi/api/action/register-share-times', // 10.0.6.登记分享页面打开次数
  checkEventCollect: activityApi + '/fmapi/api/action/collect-event', // 2.6.5 事件登记接口
  loginBocUserInFzs: activityApi + '/fmapi/api/action/record-boc-mobile-openid', // 2.4.9记录中行交易手机号和公众号用户id
}


